// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c9984b3f","556":"0697f0f5","839":"ccaf56f3"}[chunkId] + ".chunk.js";
};